// Production-ready logger that only logs in development mode
// NEVER logs in production environment
const isDevelopment = typeof import.meta !== 'undefined' && 
                     import.meta.env && 
                     (import.meta.env.MODE === 'development' || 
                      import.meta.env.DEV === true) &&
                     import.meta.env.PROD !== true;

export const logger = {
  log: (...args: any[]) => {
    if (isDevelopment) {
      console.log(...args);
    }
  },
  
  error: (...args: any[]) => {
    if (isDevelopment) {
      console.error(...args);
    }
  },
  
  warn: (...args: any[]) => {
    if (isDevelopment) {
      console.warn(...args);
    }
  },
  
  info: (...args: any[]) => {
    if (isDevelopment) {
      console.info(...args);
    }
  },
  
  debug: (...args: any[]) => {
    if (isDevelopment) {
      console.debug(...args);
    }
  }
};
